"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComparisonParser = void 0;
var _services = require("../../../services");
class ComparisonParser {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  comparisonPlanName(condition) {
    return _services.locale.localeString('Recommendation.PlanName');
  }
  productName(product) {
    return product.productName;
  }
}
exports.ComparisonParser = ComparisonParser;